export default {
  __html: `<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                <g transform="translate(-5.000000, -6.000000)" stroke-width="2" stroke="currentColor">
                    <polyline id="Mark" points="15 7 8.51694215 13 6 10.6705972"></polyline>
                </g>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/check.js